<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 1024 1024" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <path d="M835.9 285.4c5.2-5.2 11-11 14.8-17.6 28.3-35.1 31.7-88.3 7.9-126.8-23.9-38.9-59.3-58.6-105.3-58.6h-569c-11 0-22.4 0-32.3 3.1-24.3 5.9-46.5 20.2-62.6 40.5C73 146.6 64 172.1 64 197.7c0 33.3 12.7 62.8 35.7 83.1 73.2 70.7 146.2 143.7 216.9 214.4v233.3l.1 2c3.8 30.7 27.2 47.5 55.4 35.4l.5-.2c15.3-7.6 24-23 24-42.2v-240c0-16.2-5-29.4-14.8-39.2-35.3-35.3-70.1-72-103.7-107.5-34.7-36.6-70.5-74.4-108-111.9l-1.8-1.9-2.2-1.1c-.5-.4-1.7-1.9-2.5-3-1-1.2-1.9-2.4-2.9-3.5-6.5-8.3-7.8-15.3-4.8-24.9 5.3-11.9 15.8-25.5 28.6-25.5h574.1c7 0 13.7 3.8 19 10.6 6.8 8.9 9.3 20.7 6.5 31-1.4 5.7-3.8 8.3-11 15.4-79.1 76.5-154.6 152-234.5 231.9l-.4.4c-8.1 8.1-17.4 19.9-17.4 39.2v403.2c0 5 0 18.9 10.2 30.1 0 0 3.1 7 16.5 12.1 16.5 6.3 32.7-.9 32.7-.9l4.2-3.2c16.5-12.4 16.5-31.7 16.5-43.3V510.4c39.5-39.4 80.5-77.8 120.1-114.9 40.2-37.8 78.3-73.5 114.9-110.1zm56.7 261.4" />
      <path d="M912.2 526.8H722.4c-19.8 0-31.7 18.4-31.7 36.2v5.1c0 22.7 16.1 36.2 31.7 36.2h189.7c19.8 0 31.7-18.4 31.7-36.2V563c.1-21.6-12.7-36.2-31.6-36.2zm0 168.7H722.4c-19.8 0-31.7 18.4-31.7 36.2v5.1c0 22.7 16.1 36.2 31.7 36.2h189.7c19.8 0 31.7-18.4 31.7-36.2v-5.1c.1-21.7-12.7-36.2-31.6-36.2zm0 168.6H722.4c-19.8 0-31.7 18.4-31.7 36.2v5.1c0 22.7 16.1 36.2 31.7 36.2h189.7c19.8 0 31.7-18.4 31.7-36.2v-5.1c.1-21.7-12.7-36.2-31.6-36.2z" />
    </g>
  </svg>
</template>
<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
